import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';

import NavElements from 'flarum/newvigation/components/NavElements';
import LinkButton from 'flarum/common/components/LinkButton';

export default function addLeaderboardLink() {
	if (!app.initializers.has('glowingblue-newvigation')) return;

	extend(NavElements.prototype, 'items', function (items) {
		if (!app.forum.attribute('glowingblue-gamilytics.gamification.enabled')) return;

		items.add(
			'leaderboard',
			<LinkButton href={app.route('leaderboard')} icon="far fa-hiking">
				{app.translator.trans('glowingblue-orell-gamilytics.forum.nav.leaderboard')}
			</LinkButton>,
			136
		);
	});
}
